//Algolia CUSTOMIZATIONS:







// Change place holder for search boxes on facets
window.addEventListener('load', () => {
  const inputField = document.querySelector('input.ais-SearchBox-input[placeholder="Search for products"]');
  if (inputField) {
      // Change the placeholder text
      inputField.placeholder = "Filter...";    
  }
});

//Overwrite Algolia's page title
document.addEventListener('DOMContentLoaded', () => {
  const searchPageTitle = "TripleClamp Moto -Search...";
  const searchPath = "search";

  // Check if the current URL starts with "search"
  if (window.location.pathname.startsWith(`/${searchPath}`)) {
    document.title = searchPageTitle;

    // Monitor and revert changes to the document.title
    const observer = new MutationObserver(() => {
      if (document.title !== searchPageTitle) {
        document.title = searchPageTitle;
      }
    });

    // Start observing the <title> element for changes
    const titleElement = document.querySelector('title');
    if (titleElement) {
      observer.observe(titleElement, { childList: true });
    }
  }
});

const TCM_FACET_SEARCH_THRESHOLD = 15;
let tcmFacetSearchObserver = null;
let tcmFacetSearchUpdateTimer = null;
let tcmFacetSearchObserverStarted = false;
const TCM_MOBILE_FILTER_BREAKPOINT = 989;

function updateFacetSearchVisibility() {
  const facetWrappers = document.querySelectorAll('.ais-page .ais-facets .ais-facet-dropdown-wrapper');

  facetWrappers.forEach((wrapper) => {
    const searchBox = wrapper.querySelector('.ais-SearchBox');
    if (!searchBox) {
      return;
    }

    const optionCount = wrapper.querySelectorAll('.ais-facet--item').length;
    const shouldHideSearchBox = optionCount > 0 && optionCount <= TCM_FACET_SEARCH_THRESHOLD;
    wrapper.classList.toggle('tcm-facet-search-hidden', shouldHideSearchBox);
  });
}

function scheduleFacetSearchVisibilityUpdate() {
  window.clearTimeout(tcmFacetSearchUpdateTimer);
  tcmFacetSearchUpdateTimer = window.setTimeout(() => {
    updateFacetSearchVisibility();
    setupFacetModalBehavior();
  }, 80);
}

function startFacetSearchVisibilityObserver() {
  if (tcmFacetSearchObserverStarted || !document.body) {
    return;
  }

  tcmFacetSearchObserverStarted = true;
  tcmFacetSearchObserver = new MutationObserver(scheduleFacetSearchVisibilityUpdate);
  tcmFacetSearchObserver.observe(document.body, { childList: true, subtree: true });
  scheduleFacetSearchVisibilityUpdate();
}

function setupFacetModalBehavior() {
  const pages = document.querySelectorAll('.ais-page');

  pages.forEach((page) => {
    if (page.dataset.tcmFacetModalBound === 'true') {
      return;
    }

    const openButton = page.querySelector('.ais-facets-button');
    const facetsPanel = page.querySelector('.ais-facets');
    const overlay = page.querySelector('.tcm-facets-overlay');
    const closeButton = page.querySelector('.tcm-facets-close');

    if (!openButton || !facetsPanel || !overlay || !closeButton) {
      return;
    }

    const closeModal = () => {
      page.classList.remove('tcm-facets-modal-open');
      document.body.classList.remove('tcm-facets-modal-open');
      document.documentElement.classList.remove('tcm-facets-modal-open');
      openButton.setAttribute('aria-expanded', 'false');
    };

    const openModal = () => {
      page.classList.add('tcm-facets-modal-open');
      document.body.classList.add('tcm-facets-modal-open');
      document.documentElement.classList.add('tcm-facets-modal-open');
      openButton.setAttribute('aria-expanded', 'true');
    };

    openButton.addEventListener(
      'click',
      (event) => {
        if (window.innerWidth > TCM_MOBILE_FILTER_BREAKPOINT) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        openModal();
      },
      true
    );

    overlay.addEventListener('click', closeModal);
    closeButton.addEventListener('click', closeModal);

    // Keep wheel scrolling inside modal and block scroll behind overlay.
    overlay.addEventListener(
      'wheel',
      (event) => {
        event.preventDefault();
      },
      { passive: false }
    );

    facetsPanel.addEventListener(
      'wheel',
      (event) => {
        // Do not interfere on desktop. Native wheel behavior handles nested facet scrolling better.
        if (!page.classList.contains('tcm-facets-modal-open') || window.innerWidth > TCM_MOBILE_FILTER_BREAKPOINT) {
          return;
        }

        const deltaY = event.deltaY;
        const atTop = facetsPanel.scrollTop <= 0;
        const atBottom = facetsPanel.scrollTop + facetsPanel.clientHeight >= facetsPanel.scrollHeight - 1;

        // Only block background page scroll when the mobile modal itself is at the edge.
        if ((deltaY < 0 && atTop) || (deltaY > 0 && atBottom)) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    window.addEventListener('resize', () => {
      if (window.innerWidth > TCM_MOBILE_FILTER_BREAKPOINT) {
        closeModal();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    });

    page.dataset.tcmFacetModalBound = 'true';
  });
}

document.addEventListener('DOMContentLoaded', startFacetSearchVisibilityObserver);
window.addEventListener('load', scheduleFacetSearchVisibilityUpdate);

document.addEventListener('algolia.hooks.initialize', function() {
  startFacetSearchVisibilityObserver();
  window.setTimeout(scheduleFacetSearchVisibilityUpdate, 200);
});







//Algoria Custom Hooks
//https://www.algolia.com/doc/integration/shopify/building-search-ui/frontend-custom-events/?client=ruby#beforeinstantsearchproducttemplate





document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${algoliaShopify.translation_helpers.render_title(
            resource,
            state.query
          )}
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
  });
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Change the placeholder text of the autocomplete menu
    options.placeholder = "Search...";
    return options;
  });
});


document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteMainTemplate',
    function (_defaultTemplate, { html }, elements, displaySuggestions) {
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left">
              ${displaySuggestions &&
                html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">
                      ${algoliaShopify.translations.suggestions}
                    </span>
                    <div class="aa-SourceHeaderLine" />
                  </div>
                  ${elements.querySuggestionsPlugin}
                `}

              ${elements.collections}
              ${elements.articles}

              <!-- Custom Title -->
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle">Pages and Vehicles</span>
                <div class="aa-SourceHeaderLine" />
              </div>

              <!-- The default pages block, with its header visually hidden via CSS -->
              <div class="aa-HideInternalPagesHeader">
                ${elements.pages}
              </div>

              ${elements.redirectUrlPlugin}
            </div>
            <div class="aa-PanelSection--right">
              ${elements.products}
            </div>
          </div>
        </div>
      `;
    }
  );
});




























/*Template for the main template container.*/
document.addEventListener('algolia.hooks.initialize', function() { 
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {    
    return html`
      <div class="ais-page">
       <!-- <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1> -->
     
       
        
        
        <button class="ais-facets-button" type="button" aria-expanded="false">
          Show filters
        </button>
        <div class="tcm-facets-overlay"></div>
        
        <div class="ais-facets">
          <div class="tcm-facets-modal-header">
            <strong>Filters</strong>
            <button class="tcm-facets-close" type="button" aria-label="Close filters"> X </button>
          </div>
          <!-- <div class="ais-input"> -->
            <div id="collection-search-input" class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          <!--</div> -->
          <!-- <div class="TCM-Filters__heading_name">Filters</div>-->
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy} 
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy} : ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
});

/* Template for stats text shown above results. */
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
    const nbHits = Number(data?.nbHits || 0);
    const page = Number(data?.page || 0);
    const hitsPerPage = Number(data?.hitsPerPage || 24);
    const processingTimeMS = Number(data?.processingTimeMS || 0);

    if (nbHits <= 0) {
      return html`No products found`;
    }

    const start = page * hitsPerPage + 1;
    const end = Math.min((page + 1) * hitsPerPage, nbHits);
    const timeInSec = (processingTimeMS / 1000).toFixed(3);

    return html`${start} - ${end} of ${nbHits}`;
  });
});



//Facet options




document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
    
    // Loop through the facet widgets.
    const widgets = options.facets.widgets.map(widget => {
      // Only update the refinementList widget params.
      if (widget.name !== 'refinementList') {
        return widget;
      }

      // This updates all refinementList widgets.
      // If you only want to update specific facet(s),
      // you can target them by checking the value of widget.params.container. 
      
      return {
        ...widget,
        params: {
          ...widget.params,
          limit: 500,
          showMoreLimit:1000,
          showMore: false,
        }
      }
    });
    
    return {
      ...options,
      facets: {
        ...options.facets,
        widgets
      }
    };
  });
});










/*Template for product hits in the search results.*/
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {

    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
        

        <img
          class="ais-hit--picture"
          src="${algoliaShopify.helpers.largeImage(hit)}"
          alt="${hit.title} - ${hit.variant_title}"
          
        />
        <div class="TCM-product-item__label-list" >
         
            ${hit?.price_ratio && (1 - hit.price_ratio) > 0.03 ? html`<span class="TCM-product-label TCM-product-label--on-sale">${Math.round((1 - hit.price_ratio)*100)}% OFF</span>` : ''}
            ${hit?.named_tags["__label1"] ? html`  <span class="TCM-product-label TCM-product-label--custom1">${hit.named_tags["__label1"]}</span>` : ''}
            ${hit?.named_tags["__label2"] ? html`  <span class="TCM-product-label TCM-product-label--custom2">${hit.named_tags["__label2"]}</span>` : ''}
           
            <!--${hit?.tags?.map(tag => html`<span class="TCM-product-label TCM-product-label--custom1">${tag}</span>`)}-->
        </div>



        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              onclick="void(0)"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
         
               
          <!--<p class="ais-hit--price ais-hit--price-striked">${html`<span>${hit.variants_compare_at_price_min}</span> - <span>${hit.variants_compare_at_price_max}</span>`}</p>-->
          <div class="ais-hit--price">
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>            
          </div>


          <div class="TCM-res-inventory">
            ${hit.inventory_available ? (hit.variants_inventory_count <= 0 ? html`<span class="TCM-res--Available">Available</span>` : html`<span class="TCM-res--in-stock">In-stock</span>`) : html`<span class="TCM-res--out-of-stock">out-of-stock</span>` }
          </div>
          
                 
         
         

          
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });
});



/*AUTO COMPLETE Hooks */

/*Template for rendering each product hit in the autocomplete results.*/
document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      itemLink += `?variant=${item.objectID}`; 
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.compactImage(item)}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">          
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );
});
